import { Input, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface PayInputFieldProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  size?: "large" | "medium";
  fontSize?: string;
  maxWidth?: string;
}

export function PayInputField(props: PayInputFieldProps) {
  const {
    value,
    onChange,
    label = "Your hourly rate guess:",
    size = "large",
    fontSize = "2.5rem",
    maxWidth = "200px",
  } = props;

  return (
    <Stack spacing={5} sx={{ width: "100%", alignItems: "center" }}>
      <Text variant="body1" sx={{ textAlign: "center" }}>
        {label}
      </Text>

      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{
          width: "100%",
          maxWidth: "360px",
          justifyContent: "center",
        }}
      >
        <Text
          variant="body1"
          sx={{
            fontSize: size === "large" ? "1.5rem" : "1.25rem",
            color: (theme) => theme.palette.text.secondary,
          }}
        >
          $
        </Text>
        <Input
          value={value}
          placeholder=""
          size={size}
          inputProps={{
            inputMode: "decimal",
            "aria-label": label,
          }}
          sx={{
            width: "100%",
            maxWidth,
            "& .MuiInputBase-root": {
              borderRadius: 3,
            },
            "& .MuiInputBase-input": {
              textAlign: "center",
              fontSize,
              fontWeight: 600,
            },
          }}
          onChange={(event) => {
            const sanitized = event.target.value
              .replace(/[^0-9.]/g, "")
              .replace(/(\..*)\./g, "$1")
              .replace(/^(\d*\.\d{2}).*$/, "$1");

            onChange(sanitized);
          }}
        />
        <Text
          variant="body1"
          sx={{
            fontSize: size === "large" ? "1.5rem" : "1.25rem",
            color: (theme) => theme.palette.text.secondary,
          }}
        >
          /hr
        </Text>
      </Stack>
    </Stack>
  );
}
